import React from 'react';
import cn from 'classnames';
import { getContactHrefByType } from 'shared/lib/contentModules';
import { peoplePublicPropTypes } from 'shared/proptypes/ContentModule';
import { personContactIcons } from 'shared/components/Icon/icons';
import WysiwygContent from 'shared/components/WysiwygContent';
import { STATIC_BASE_URL } from 'shared/routes';
import styles from './People.module.scss';

const ContentModuleViewText = ({
  photoSize,
  photoStyle,
  display,
  cols,
  title,
  description,
  persons
}) => (
  <>
    {title && (<h2>{title}</h2>)}
    {description && (
      <WysiwygContent>{description}</WysiwygContent>
    )}
    <div
      className={cn(
        styles.persons,
        styles[`photoStyle-${photoStyle}`],
        styles[`display-${display}`],
        styles[`cols-${cols}`],
      )}
    >
      {persons.map(person => (
        <div key={person.id} className={styles.person}>
          <div className={styles.photoCol}>
            <img src={`${STATIC_BASE_URL}${person.url}`} style={{ width: photoSize, minWidth: photoSize }} alt="" />
          </div>
          <div className={styles.contentCol}>
            <h3>{person.name}</h3>
            {person.headline && (<h4>{person.headline}</h4>)}
            {person.description && (<p>{person.description}</p>)}
            {person.contacts.length > 0 && (
              <div className={styles.contacts}>
                {person.contacts.map((contact, i) => (
                  <a key={i} href={getContactHrefByType(contact.type, contact.value)} target="_blank" rel="noopener noreferrer">
                    <i className={personContactIcons[contact.type]} />
                  </a>
                ))}
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  </>
);

ContentModuleViewText.propTypes = peoplePublicPropTypes;

export default ContentModuleViewText;
